const currentLanguages = ['fi', 'en']

const isLanguageString = (input: any) =>
  currentLanguages.find((language) => language === input)

export { currentLanguages, isLanguageString }
